import { useEffect, useState } from 'react';

export function useMedia(query: string): boolean {
  const [match, setMatch] = useState(() =>
    typeof window === 'undefined' ? false : window.matchMedia(query).matches,
  );
  useEffect(() => {
    const mq = window.matchMedia(query);
    const cb = () => setMatch(mq.matches);
    cb();
    mq.addEventListener('change', cb);
    return () => mq.removeEventListener('change', cb);
  }, [query]);
  return match;
}

// breakpoint di §2.8
export function useBreakpoint() {
  const xl = useMedia('(min-width: 1440px)');
  const lg = useMedia('(min-width: 1200px)');
  const md = useMedia('(min-width: 1024px)');
  const sm = useMedia('(min-width: 768px)');
  return { xl, lg, md, sm, xs: !sm, collapsed: !lg && md, drawerNav: !sm };
}
